// extracted by mini-css-extract-plugin
export default {"svg_icon":"SvgIcon_svg_icon__sO-w5"};